import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {  BrowserRouter as Router} from "react-router-dom";
import ScrollTopTop from '../src/hooks/scrollTop'

ReactDOM.render(
  <React.StrictMode>
    <Router>
   
      <ScrollTopTop />

      <App />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
